
/**
  // Logos with their cooresponding coordinates
 *
 */
import produce from 'immer';
import { enableES5 } from "immer"
import { floorCode } from "config/constants";
import verticesOnFloor, { titleRotatesOnFloor } from "config/verticesOnFloor";
import * as actionTypes from "../actions/actionTypes";
import slotsApiMapping from 'config/slotsApiMapping.json';

enableES5();
const initialState = {
  [floorCode[1]]: [],
  [floorCode[2]]: [],
  [floorCode[3]]: []
};

const reshapeInitialState = slot => {
  const { floorLevel } = slot;
  const ele = verticesOnFloor[floorLevel].find(vertex => (vertex && vertex.id === slot.svgId));
  if (!ele) return; // Skip if the vertex no longer exists

  const titleRotate = titleRotatesOnFloor[floorLevel]?.find(tr => tr.id === slot.id)?.rotate || 0;
  const logoCoor = {
    id: slot.id,
    svgId: slot.svgId,
    cx: ele.cx,
    cy: ele.cy,
    position: ele.position,
    rotate: titleRotate,
  }
  initialState[floorCode[floorLevel]].push(logoCoor);
};

slotsApiMapping.forEach(item => {
  reshapeInitialState(item)
});

const mutateState = (payload, prevState) => {
  return produce(prevState, state => {
    let logos = [];
    if (Array.isArray(payload)) {
      logos = payload;
    } else if (payload.categories && Array.isArray(payload.categories)) {
      // Flatten categories if they contain shops
      payload.categories.forEach(category => {
        if (category.shops && Array.isArray(category.shops)) {
          logos = logos.concat(category.shops);
        } else if (category.items && Array.isArray(category.items)) {
          logos = logos.concat(category.items);
        } else {
          logos.push(category);
        }
      });
    } else if (payload.data && Array.isArray(payload.data)) {
      logos = payload.data;
    } else if (payload.list && Array.isArray(payload.list)) {
      logos = payload.list;
    } else {
      // If no array found, return
      return;
    }
    logos.forEach(item => {
      const floor_code = item.floor_code || item.floor || item.floor_id;
      const code = item.code || item.id || item.slot;
      const targetEle = state[floor_code]?.find(ele => ele.id === code);
      if (targetEle) {
        if (item.negative_logo !== false) {
          targetEle.href = item.negative_logo || item.logo;
        }
        targetEle.logoSize = item.negative_logo_size || item.logo_size;
        targetEle.title = item.title || item.name;
        if (item.position) {
          targetEle.position = item.position;
        }
        if (item.rotate !== undefined) {
          targetEle.rotate = item.rotate;
        }
      }
    });
  });
};

const codeListReducer = (state = initialState, { type, payload }) => {
  switch (type) {

    case actionTypes.SET_LIST_OF_CODES:
      return mutateState(payload, state);
    default:
      return state
  }
}

export default codeListReducer;

